import ServerPath from '../../server-path/server-path';
let UtilService = require("../../services/util.service");
let Encrypted = require("../../services/encrypted");

import Axios from 'axios'

import {
    SET_LOGGED_IN,
    UNSET_LOGGED_IN,
    SET_MESSAGE,
    UNSET_MESSAGE,
    SET_AUTH_USER,
    SET_USER_ROLE,
    SET_USER_ROLE_DATA,
    SET_USER_TYPE,
    SET_ACCESS_MENU_LINK,
} from '../mutation-types'

import {
    toastMessage, FillUpRequiredFiled, emptyData
} from '../erpUtil'

// initial state

const state = {

    loggedIn: false,
    dashboardLoaded: false,
    user_id: 0,
    institute_id: 0,
    institute_name: '',
    message: "",
    user_type: 0,
    userRole: { saveButton: 0, updateButton: 0, deleteButton: 0, viewButton: 0, financeButton: 0 },
    authUser: {
        user_id: 0,
        user_name: '',
        password: '',
        role_id: '',
        institute_id: '',
        upload_id: '',
        institute_name_bn: '',
        institute_name_en: '',
        email: '',
        mobile: '',
        phone: '',
        social_type: '',
        type_id: 0,
        home_id: '',
    },
    dashboardDataList: [],
    userRoleDetails: [],
    accessMenuLink: [],
}

const getters = {

    getLoggedIn(state) {
        return state.loggedIn;
    },
    getUserId(state) {
        return state.user_id
    },
    getInstituteName(state) {
        return state.institute_name
    },
    getInstituteId(state) {
        return state.institute_id
    },
    getAuthUser(state) {
        return state.authUser
    },
    getMessage(state) {
        return state.message
    },

    getDashboardDataList(state) {
        return state.dashboardDataList
    },
    getDashboardDataLoadStatus(state) {
        return state.dashboardLoaded
    },
    getUserRoleDetails(state) {
        return state.userRoleDetails
    },

    get_USER_ROLE_DATA(state) {
        return state.userRole
    },
    getInspectionData(state) {
        return state.inspectionData
    },
    getInspectionId() {
        return state.inspectionId
    },
    getInspectionForwardBackwards(state) {
        return state.inspectionReviewForwardBackwards;
    },
    getInspectionReviewerData(state) {
        return state.inspectionReviewerData;
    },
    getUserType(state) {
        return state.user_type;
    },
    getFillUpAllRequiredField() {
        return { 'color': 'error', 'message': FillUpRequiredFiled };
    },
    getEmptyData() {
        return emptyData;
    },
    getFormNumber() {
        return state.formNumber;
    },
    getCommentFormNumber() {
        return state.commentFormNo;
    },
    getAccessMenuLink() {
        return state.accessMenuLink;
    },

}

// mutations
const mutations = {
    [SET_LOGGED_IN](state, id) {
        state.user_id = id
        state.loggedIn = true
    },

    [UNSET_LOGGED_IN](state) {
        state.user_id = 0
        state.loggedIn = false,
            state.user_type = 0,
            state.authUser = {
                user_id: 0,
                user_name: '',
                first_name: '',
                last_name: '',
                email: '',
                mobile: '',
                phone: '',
                street_address: '',
                city: '',
                state: '',
                zip: '',
                pic_path: '',
                user_profile_id: '',
                password_confirmation: '',
                profile_id: '',
                upload_id: '',
                social_id: '',
                social_type: '',
                uuid: '',
                type_id: 0,
            },
            state.accessMenuLink = []

    },
    [SET_AUTH_USER](state, user) {
        state.authUser = user
    },
    [SET_MESSAGE](state, Msg) {
        state.message = Msg
    },
    [UNSET_MESSAGE](state) {
        state.message = ""
    },   
    [SET_USER_ROLE_DATA](state, roleDetails) {
        state.userRoleDetails = roleDetails
    },
    [SET_USER_ROLE](state, rolesData) {
        state.userRole.viewButton = Number(rolesData.read)
        state.userRole.saveButton = Number(rolesData.save)
        state.userRole.updateButton = Number(rolesData.update)
        state.userRole.deleteButton = Number(rolesData.delete)
        state.userRole.financeButton = Number(rolesData.finance)
    },
    [SET_USER_TYPE](state, typeId) {
        state.user_type = typeId
    },
    [SET_ACCESS_MENU_LINK](state, links) {
        state.accessMenuLink = links
    },

}
// Actions
const actions = {

    authenticateUser({ commit, state }, { user }) {

        const uri = `${ServerPath.serverPath}/api/login`;

        var params = new URLSearchParams();
        params.append('email', user.email);
        params.append('password', user.password);
        params.append('project_id', user.project_id);

        return new Promise((resolve, reject) => {

            Axios.post(uri, params)
                .then(function (response) {
                    
                    var storeVal = response.data.store
                    //console.log('response.data == ', response.data.accessToken);
                    if (response.data.status == "success") {
                        UtilService.setToken(response.data.accessToken);

                        commit('SET_USER_ROLE_DATA', response.data.roleDetails)

                        let encodeString = Encrypted.base64_encode(JSON.stringify(response.data.menuUrl));
                        sessionStorage.setItem("m", encodeString); 
                        
                        commit('SET_ACCESS_MENU_LINK', response.data.menuUrl)

                        sessionStorage.setItem('auth', 'yes');
                        sessionStorage.setItem('proId', response.data.projectInfo.id);

                        let encodeString2 = Encrypted.base64_encode(JSON.stringify(response.data.roleDetails));
                        localStorage.setItem('roleDetails', encodeString2);
                        
                        //localStorage.setItem('roleDetails', JSON.stringify(response.data.roleDetails));                                                
                        commit('UNSET_MESSAGE')
                        
                        let encodeString3 = Encrypted.base64_encode(JSON.stringify(response.data.projectInfo));
                        localStorage.setItem('projectInfo', encodeString3);
                        commit('SET_PROJECT_INFO',response.data.projectInfo);

                        resolve(response.data)
                    } else {
                        resolve(response.data)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    reject()
                });

        })
    },
    checkAuthentication({ commit }) {

        if (localStorage.getItem('user_id') > 0)
            commit('SET_LOGGED_IN')
    },
   
}

export default {
    state,
    getters,
    actions,
    mutations,

}    	 


// WEBPACK FOOTER //
// ./src/vuex/module/common.js